// extracted by mini-css-extract-plugin
module.exports = {"override":"override--2b599","checkInOverride":"checkInOverride--35cf3"};